export enum TrackingCategory {
  Account = 'Account',
  Auth = 'Auth',
  CRM = 'CRM',
  Casino = 'Casino',
  Deposit = 'Deposit',
  ManageCurrencies = 'Manage Currencies',
  P2pTransfer = 'P2P Transfer',
  PaymentMethods = 'Payment Methods',
  RMF = 'RMF',
  Rewards = 'Rewards',
  Signup = 'Signup',
  Sports = 'Sports',
  Stars = 'Stars',
  TransactionHistory = 'Transaction History',
  Withdraw = 'Withdraw'
}
